import { render, staticRenderFns } from "./voice_video.vue?vue&type=template&id=a3979a0e&scoped=true"
import script from "./voice_video.vue?vue&type=script&lang=ts"
export * from "./voice_video.vue?vue&type=script&lang=ts"
import style0 from "./voice_video.vue?vue&type=style&index=0&id=a3979a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3979a0e",
  null
  
)

export default component.exports